import React from 'react';
import classNames from 'classnames';

export default function Popup({
    visible,
    setVisible,
    overflow,
    paddingTop,
    fullScreen,
    small,
    medium,
    children,
    popupClassName = "",
    containerClassName = ""
}) {
    const containerClasses = typeof containerClassName === "string" ? containerClassName.split(" ").reduce((acc, item) => ({...acc, [item]: true}), {}) : containerClassName;
    const popupClasses = typeof popupClassName === "string" ? popupClassName.split(" ").reduce((acc, item) => ({...acc, [item]: true}), {}) : popupClassName;

    const ContainerClasses = classNames({
        "fixed inset-0 overflow-y-auto w-full h-full flex items-center justify-center top-0 left-0 z-200": true, "pt-80": paddingTop,
        "pointer-events-none": !visible,
        ...containerClasses
    })

    const OverlayClasses = classNames({
        "simple-popup-overlay fixed w-full h-full top-0 left-0 flex items-center bg-black bg-opacity-50 transition-opacity ease-in-out": true,
        "opacity-0": !visible,
        "opacity-100": visible
    })

    const Classes = classNames({
        "simple-popup relative bg-white rounded-xl transform border border-line ease-in-out max-w-90vw mb-10 md:mb-0": true,
        "w-500": !small && !medium && !fullScreen,
        "overflow-visible": overflow === 'visible',
        "overflow-auto": !overflow,
        "w-380": small && !fullScreen,
        "w-600": medium && !fullScreen,
        "max-h-80vh": !fullScreen,
        "w-full h-full max-h-90vh": fullScreen,
        "opacity-0 scale-95": !visible,
        "transition-all opacity-100 scale-10": visible,
        ...popupClasses
    })

    const onClickHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if(typeof setVisible !== 'function') {
            return console.error('setVisible is not a function');
        }
        return setVisible(false);
    }

    return (
        <div className={ContainerClasses}>

            <div className={OverlayClasses} onClick={onClickHandler}></div>

            <div className={Classes}>
                {visible && children}
            </div>
        </div>
    )
}
